import { Affiliate } from '@agria/paws/src/types';

type AffiliateType = 'vet' | 'breeder' | 'rehoming';

interface ValidateAffiliateLoginProps {
  affiliate: Affiliate;
  affiliateType: AffiliateType;
  affiliateTypeIds: string[];
}

interface ValidateAffiliateLoginResult {
  affiliateTypeError: boolean;
  invalidStatusIdError: boolean;
  isAllowed: boolean;
}

const VET_ACTIVATED_STATUS_ID = '8da68463-0134-4a4a-8412-870a022693b7';

const normalizeGuid = (value?: string | null) => value?.toLowerCase() ?? '';

export const validateAffiliateLogin = ({
  affiliate,
  affiliateType,
  affiliateTypeIds,
}: ValidateAffiliateLoginProps): ValidateAffiliateLoginResult => {
  const normalizedAffiliateTypeIds = affiliateTypeIds
    .map((affiliateTypeId) => normalizeGuid(affiliateTypeId))
    .filter(Boolean);
  const affiliateTypeId = normalizeGuid(affiliate.AffiliateTypeId);

  if (
    normalizedAffiliateTypeIds.length > 0 &&
    !normalizedAffiliateTypeIds.includes(affiliateTypeId)
  ) {
    return {
      affiliateTypeError: true,
      invalidStatusIdError: false,
      isAllowed: false,
    };
  }

  if (
    affiliateType === 'vet' &&
    normalizeGuid(affiliate.AppointedRepresentativeStatusId) !==
      VET_ACTIVATED_STATUS_ID
  ) {
    return {
      affiliateTypeError: false,
      invalidStatusIdError: true,
      isAllowed: false,
    };
  }

  return {
    affiliateTypeError: false,
    invalidStatusIdError: false,
    isAllowed: true,
  };
};
